import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic_check",
  "use": "ic_check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"ic_check\">\n    <polygon id=\"ic_check_path-1\" points=\"8.72727273 16.2835821 4.43181818 12.2089552 3 13.5671642 8.72727273 19 21 7.35820896 19.5681818 6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol